import React from "react";
import { formatCurrency } from "@/lib/currency";

export const RoundsHistory = ({ a }) => {
  const rounds = a.rounds || [];
  return (
    <div className="mt-10" data-testid="rounds-history">
      <div className="border-b border-black pb-3 mb-0 flex items-baseline justify-between">
        <h3 className="font-display font-extrabold text-2xl tracking-tightest">Rounds History</h3>
        <span className="text-[10px] tracking-[0.25em] uppercase text-neutral-500">{rounds.length} rounds</span>
      </div>
      <div className="divide-y divide-black/10 border-b border-black/10">
        {rounds.map((r, i) => {
          const summary = a.round_summary?.find((s) => s.round === r.round);
          const myBid = a.my_bids?.find((b) => b.round === r.round);
          return (
            <div key={r.round} className="grid grid-cols-12 gap-4 py-4 items-center" data-testid={`round-row-${r.round}`}>
              <div className="col-span-2 font-mono-plex text-lg">R{r.round}</div>
              <div className="col-span-4">
                <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-500">Target</div>
                <div className="font-mono-plex">{r.target_price != null ? formatCurrency(r.target_price, a.currency) : "—"}</div>
              </div>
              <div className="col-span-3">
                <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-500">{a.is_creator ? "Bids" : "My Bid"}</div>
                <div className="font-mono-plex">
                  {a.is_creator
                    ? (summary ? `${summary.bid_count}` : "0")
                    : (myBid ? formatCurrency(myBid.price, a.currency) : "—")}
                </div>
              </div>
              <div className="col-span-3">
                <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-500">{a.is_creator ? "Lowest" : "Status"}</div>
                <div className="font-mono-plex">
                  {a.is_creator
                    ? (summary?.lowest_price != null ? formatCurrency(summary.lowest_price, a.currency) : "—")
                    : (i === rounds.length - 1 ? "Active" : "Ended")}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
